import api from "../../http";

export default class ApiSolutionsCasinoSecondSectionStage {
    static async getApiSolutionsCasinoSecondSectionStage(url) {
        return api.get(url)
    }
}